// Lista predefinita degli "Stati Aggiuntivi" pratica (gestibile da Impostazioni Studio).
export const DEFAULT_STATI = [
  "ATTESA APERTURA SINISTRO",
  "Attesa Assegno in St.+ On. con Bonifico studio",
  "Attesa Bonifico al cliente + On. con Bonifico studio",
  "Attesa Bonifico al riparatore + On. con Bonifico studio",
  "Attesa contatto dal Perito",
  "Attesa contatto dalla c.te per proseguo istruttoria",
  "Attesa contatto per definizione",
  "ATTESA COPERTURA ASSICURATIVA da CONSAP",
  "Attesa dich. testimoniale",
  "ATTESA DOCUMENTI DAL CLIENTE",
  "ATTESA ESITO ARBITRATO",
  "Attesa informazioni dal cliente",
  "Attesa Onorari su Iban studio",
  "Attesa Pag.con assegno di traenza - OMNIA -",
  "Attesa Pagamento ad Integrazione",
  "Attesa Pagamento con assegno CIRCOLARE",
  "Attesa Pagamento con assegno di traenza",
  "Attesa Pagamento con Bonifico al Cliente",
  "Attesa Pagamento con Bonifico al RIPARATORE",
  "Attesa Pagamento con Bonifico allo studio",
  "Attesa Pagamento Parziale",
  "ATTESA Rapp. P.M.",
  "Attesa Risposta Flusso Telematico",
  "ATTESA SCADENZA FLUSSO TELEMATICO C.TE",
  "Attesa scadenza termini risposta c.te",
  "Attesa Visita medica di controparte",
  "Attesa Visura P.R.A.",
  "C.te Nega Evento",
  "Chiusa senza seguito - Pratica in prescrizione",
  "Chiusa senza seguito. Contestata per danno non compatibile",
  "Contestata per mancata resp. di controparte",
  "Definita a saldo e stralcio.",
];
